// Libs
import { HOME } from '@/lib/routes/privateRoutes';

// Components
import { SingleMenuEntry } from '@/components/composite/Menu/MenuMain';
import { SingleMenuEntry as SingleMenuEntryMobile } from '@/components/composite/MenuMobile/MenuSidebarMain';

const item = {
    icon: 'explore',
    link: HOME,
    name: 'commons:menu.home',
    urlActiveMenu: [HOME]
};

const MenuHomeItem = ({ isMobile = false }: { isMobile?: boolean }) => {
    return isMobile ? (
        <SingleMenuEntryMobile
            item={item}
            hasAccess={true}
            className="menu-item-mobile px-8 pb-5"
        />
    ) : (
        <SingleMenuEntry hasAccess={true} item={item} />
    );
};

export default MenuHomeItem;
